import * as React from "react"
import { cn } from "@/lib/utils"

export interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(({ className, ...props }, ref) => (
  <input ref={ref} type="date" className={cn("h-9 rounded-md border border-input bg-background px-3 text-sm text-foreground", className)} {...props} />
))
DateInput.displayName = "DateInput"
